import { render, staticRenderFns } from "./DetalleAlojamientoLocation.vue?vue&type=template&id=508f5bf5&scoped=true"
import script from "./DetalleAlojamientoLocation.vue?vue&type=script&lang=js"
export * from "./DetalleAlojamientoLocation.vue?vue&type=script&lang=js"
import style0 from "./DetalleAlojamientoLocation.vue?vue&type=style&index=0&id=508f5bf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f5bf5",
  null
  
)

export default component.exports